import React, { useState, useEffect, useRef, useCallback } from "react";
import * as Mui from "@mui/material";
import {
  AddRoad,
  Payment,
  RemoveCircleOutline,
  VideoLabel,
  ViewCompactAlt,
  Wallet,
  Edit,
  CloudUpload,
  Calculate,
  MoreVert,
  KeyboardArrowDown,
  Autorenew,
  Undo,
  RestartAlt,
  Close,
  Error,
} from "@mui/icons-material";
import { BulkImport } from "./BulkImportPage/BulkImport";
import { themes, infoStyle } from "services/constants";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { summaryDetails, paymentOptions } from "pages/PayRoll/PayRollHeaders";
import { cardStyle } from "pages/HR/Shift/Configuration/ShiftCategory/Component/ShiftCategoryOptions";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { useSelector } from "react-redux";
import { CostStructure } from "./CostStructure/PayrunCycleDetails";
import { AttendanceTimeLine } from "./AttendanceTimeLine";
import { useDispatch } from "react-redux";
import { showToast } from "services/utils/Status";
import { amountNumberFormat } from "services/utils/numberFormat";
import { useFetch } from "services/hooks/useFetch";
import { usePayrollCycleRun } from "./PayrollCycleRunContext";
import {
  CustomButtonWithBorder,
  CustomButtonWithOutLoader,
} from "components/CustomComponents/CustomButton";
import comLogo from "../../../../assets/img/brand/company_logo.png";
import { customAPI, customGetAPI } from "services/utils/CustomAPI";
import { CustomButton } from "components/CustomComponents";
import { ConfirmationDialog } from "components/CustomComponents/ConfirmationDialog";
import { useFilter } from "pages/FilterContext";

export const ViewPayRun = ({ companyId, companyName, viewPayrunDetails }) => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const { domain } = useSelector((state) => state.tokenReducer);
  const {
    payScheduleData,
    setPayScheduleData,
    payScheduleId,
    setViewPayRunScreen,
    setActiveTab,
    isProcessing,
    processingMessage,
    paymentBasedOn,
    setPaymentBasedOn,
    setRerunLoader,
    socketCompleted,
    recallSummaryApi,
    setRecallSummaryApi,
    setSocketCompleted,
    setLogData,
  } = usePayrollCycleRun();
  const { result: summaryData, setLoad: recallApi } = useFetch(
    `${domain}payroll/operations/payrollprocessing/payrollruncycle/payrun-summary/?pay_schedule_id=${payScheduleId}&company_id=${requestCompanyId}`,
  );
  const [summaryName, setSummaryName] = useState("Cost Structure");
  const [downloadReportDetails, setDownloadReportDetails] = useState(false);
  const [rerunPayrun, setRerunPayrun] = useState(false);
  const [recallEmployee, setRecallEmployee] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [showBulkImportDialog, setShowBulkImportDialog] = useState(false);
  const [isRecalculating, setIsRecalculating] = useState(false);
  const [isStartingProcess, setIsStartingProcess] = useState(false);
  const [isApproveRejectLoading, setIsApproveRejectLoading] = useState(false);
  const [showStartProcessingDialog, setShowStartProcessingDialog] =
    useState(false);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [editNameField, setEditNameField] = useState(false);
  const [payRunName, setPayRunName] = useState("");
  const [readyForPayrollWaiting, setReadyForPayrollWaiting] = useState(false);
  const [, setReadyForPayrollMessage] = useState("");
  const [showIncompleteDataBanner, setShowIncompleteDataBanner] =
    useState(true);
  const readyForPayrollIntervalRef = useRef(null);
  const readyForPayrollElapsedRef = useRef(0);
  const readyForPayrollCancelledRef = useRef(false);
  const { setSelectedFilters, setFilterValues, setSortRules } = useFilter();
  const dispatch = useDispatch();
  const handleSummaryDetails = (event, data) => {
    if (data) {
      setSummaryName(data?.label);
      dispatch(setGlobalSearchValue(""));
    }
  };

  const renderComponent = () => {
    switch (summaryName) {
      case "Cost Structure":
        return (
          <CostStructure
            companyId={companyId}
            recallEmployee={recallEmployee}
            setRecallEmployee={setRecallEmployee}
          />
        );
      case "Attendance Timeline":
        return (
          <AttendanceTimeLine
            viewPayrunDetails={viewPayrunDetails}
            companyName={companyName}
            setDownloadReportDetails={setDownloadReportDetails}
            downloadReportDetails={downloadReportDetails}
            summaryName={summaryName}
          />
        );
      default:
        break;
    }
  };

  const payrollData = [
    {
      id: 1,
      icon: Wallet,
      label: "Payroll Cost",
      value: summaryData ? amountNumberFormat(summaryData?.payroll_cost) : 0,
      bgColor: "#F0FDFA",
      iconBgColor: "#D1FAF5",
      iconBorderColor: "#0F766E",
      iconColor: "#09BD71",
    },
    {
      id: 2,
      icon: RemoveCircleOutline,
      label: "Total deductions",
      value: summaryData ? amountNumberFormat(summaryData?.total_deduction) : 0,
      bgColor: "#FFF1F2",
      iconBgColor: "#FFE4E6",
      iconBorderColor: "#DC2626",
      iconColor: "#DC2626",
    },
    {
      id: 3,
      icon: Payment,
      label: "Net Salary",
      value: summaryData ? amountNumberFormat(summaryData?.net_salary) : 0,
      bgColor: "#F5F7FF",
      iconBgColor: "#E0E7FF",
      iconBorderColor: "#1D4ED8",
      iconColor: "#1D4ED8",
    },
    {
      id: 4,
      icon: AddRoad,
      label: "Additional Deduction",
      value: summaryData
        ? amountNumberFormat(summaryData?.additional_deduction)
        : 0,
      bgColor: "#FFF5FA",
      iconBgColor: "#FCE7F3",
      iconBorderColor: "#BE185D",
      iconColor: "#BE185D",
    },
    {
      id: 5,
      icon: VideoLabel,
      label: "Advances",
      value: summaryData ? amountNumberFormat(summaryData.advance || 0) : 0,
      bgColor: "#FFFBEB",
      iconBgColor: "#FEF3C7",
      iconBorderColor: "#D97706",
      iconColor: "#D97706",
    },
    {
      id: 6,
      icon: ViewCompactAlt,
      label: "Net Pay",
      value: summaryData ? amountNumberFormat(summaryData.net_pay) : 0,
      bgColor: "#F2FCF6",
      iconBgColor: "#E7F8EE",
      iconBorderColor: "#16A34A",
      iconColor: "#16A34A",
    },
  ];

  useEffect(() => {
    if (recallSummaryApi) {
      recallApi(true);
      setRecallSummaryApi(false);
    }
  }, [recallApi, recallSummaryApi, setRecallSummaryApi]);

  useEffect(() => {
    if (readyForPayrollWaiting) {
      setShowIncompleteDataBanner(true);
    }
  }, [readyForPayrollWaiting]);

  const stopReadyForPayrollPolling = useCallback(() => {
    if (readyForPayrollIntervalRef.current) {
      clearInterval(readyForPayrollIntervalRef.current);
      readyForPayrollIntervalRef.current = null;
    }
  }, []);

  const checkReadyForPayrollCount = useCallback(
    async (isPoll) => {
      const response = await customGetAPI(
        `${domain}payroll/earning/ready-for-payroll/counts/?payschedule_id=${payScheduleId}&company_id=${requestCompanyId}`,
      );

      if (readyForPayrollCancelledRef.current) {
        return;
      }

      const details = response?.responseDetails;
      const count =
        typeof details === "number"
          ? details
          : (details?.attendance_ready_for_payroll_count ?? 0) +
            (details?.holiday_ready_for_payroll_count ?? 0) +
            (details?.post_ot_ready_for_payroll_count ?? 0) +
            (details?.week_off_ready_for_payroll_count ?? 0);

      if (response?.ok && count > 0) {
        if (isPoll) {
          readyForPayrollElapsedRef.current += 5;
        } else {
          readyForPayrollElapsedRef.current = 0;
          showToast(
            "info",
            "Your payroll data is currently being processed. Please wait.",
          );
        }

        setReadyForPayrollWaiting(true);
        setReadyForPayrollMessage(
          readyForPayrollElapsedRef.current > 0
            ? `Your payroll data is currently being processed. Please wait. (${readyForPayrollElapsedRef.current} min)`
            : "Your payroll data is currently being processed. Please wait.",
        );

        if (!readyForPayrollIntervalRef.current) {
          readyForPayrollIntervalRef.current = setInterval(
            () => checkReadyForPayrollCount(true),
            5 * 60 * 1000,
          );
        }
      } else {
        stopReadyForPayrollPolling();
        readyForPayrollElapsedRef.current = 0;
        setReadyForPayrollWaiting(false);
        setReadyForPayrollMessage("");
      }
    },
    [domain, payScheduleId, stopReadyForPayrollPolling, requestCompanyId],
  );

  useEffect(() => {
    if (!payScheduleId) {
      return undefined;
    }

    readyForPayrollCancelledRef.current = false;
    readyForPayrollElapsedRef.current = 0;
    checkReadyForPayrollCount(false);

    return () => {
      readyForPayrollCancelledRef.current = true;
      stopReadyForPayrollPolling();
    };
  }, [payScheduleId, checkReadyForPayrollCount, stopReadyForPayrollPolling]);

  const handleIncompleteDataRefresh = useCallback(() => {
    recallApi(true);
    checkReadyForPayrollCount(false);
  }, [recallApi, checkReadyForPayrollCount]);

  useEffect(() => {
    const handleRerunPayrun = async () => {
      setRerunLoader(true);
      const response = await customAPI(
        `${domain}payroll/operations/payrollprocessing/payrollruncycle/intiate_payrun/?company_id=${requestCompanyId}`,
        "POST",
        {
          pay_schedule_id: payScheduleId,
          payment_based_on: paymentBasedOn,
          use_background_task: false,
          delete_manual_data: true,
        },
      );

      if (response.ok) {
        setShowConfirmationDialog(false);
        recallApi(true);
        showToast("success", response?.responseDetails?.message);
        setRerunPayrun(false);
        setRerunLoader(false);
        setRecallEmployee(true);
      } else {
        showToast("error", response?.message);
        setRerunPayrun(false);
        setRerunLoader(false);
      }
    };

    if (rerunPayrun) {
      handleRerunPayrun();
    }
  }, [
    domain,
    payScheduleId,
    paymentBasedOn,
    recallApi,
    rerunPayrun,
    setRerunLoader, requestCompanyId
  ]);

  const hanldePaymentBasedOn = (event) => {
    setPaymentBasedOn(event.target.value);
  };

  const handleStartProcessing = async () => {
    if (isStartingProcess) {
      return;
    }
    setIsStartingProcess(true);
    setShowStartProcessingDialog(false);
    const response = await customAPI(
      `${domain}payroll/operations/payrollprocessing/payrollruncycle/intiate_payrun/?company_id=${requestCompanyId}`,
      "POST",
      {
        pay_schedule_id: payScheduleId,
        payment_based_on: paymentBasedOn,
        use_background_task: false,
        delete_manual_data: true,
      },
    );
    if (response.ok) {
      showToast("success", response?.responseDetails?.message);
      setPayScheduleData((prev) => ({ ...prev, status: "Inprogress" }));
      setSocketCompleted(true);
      setLogData(response?.responseDetails?.data ?? []);
      recallApi(true);
    } else {
      showToast("error", response?.message);
    }
    setIsStartingProcess(false);
  };

  const handleApproveRejectReopen = async (status, activeTab) => {
    if (isApproveRejectLoading) {
      return;
    }
    setIsApproveRejectLoading(true);
    try {
      if (status === "Ready for Review") {
        await handleRecalculate(false);
      }
      const response = await customAPI(
        `${domain}payroll/operations/payrollprocessing/payrollruncycle/payschedules/?company_id=${requestCompanyId}`,
        "PUT",
        {
          pay_schedule_id: payScheduleId,
          status: status,
        },
      );
      if (response.ok) {
        showToast("success", response?.responseDetails?.message);
        if (status === "Ready for Review") {
          setPayScheduleData((prev) => ({ ...prev, status: "Ready for Review" }));
        } else {
          setActiveTab(activeTab);
          setViewPayRunScreen(false);
        }
      } else {
        showToast("error", response?.message);
      }
    } finally {
      setIsApproveRejectLoading(false);
    }
  };

  const handleRecalculate = async (notification) => {
    if (isRecalculating) {
      return;
    }
    setIsRecalculating(true);
    setRerunLoader(true);
    const response = await customAPI(
      `${domain}payroll/operations/payrollprocessing/payrollruncycle/intiate_payrun/?company_id=${requestCompanyId}`,
      "POST",
      {
        pay_schedule_id: payScheduleId,
        payment_based_on: paymentBasedOn,
        use_background_task: false,
        delete_manual_data: false,
      },
    );

    if (response.ok) {
      if (notification) {
        showToast("success", response?.responseDetails?.message);
      }
      setRecallEmployee(true);
      recallApi(true);
      setRerunLoader(false);
    } else {
      showToast("error", response?.message);
    }
    setIsRecalculating(false);
  };

  const handleCancelClose = () => {
    setShowConfirmationDialog(false);
    setPendingAction(null);
  };

  const handleConfirmDialog = () => {
    if (pendingAction === "revertDraft") {
      setShowConfirmationDialog(false);
      setPendingAction(null);
      handleApproveRejectReopen("Draft", 0);
    } else {
      setRerunPayrun(true);
    }
  };

  const isOnlySpaces = (str) => /^\s*$/.test(str);

  const updatePayRunName = async () => {
    if (payRunName === payScheduleData?.name || isOnlySpaces(payRunName)) {
      setEditNameField(false);
      return;
    }
    const response = await customAPI(
      `${domain}payroll/operations/payrollprocessing/payrollruncycle/rename-payschedule/?company_id=${requestCompanyId}`,
      "PUT",
      {
        pay_schedule_id: payScheduleId,
        name: payRunName,
      },
    );
    if (response.ok) {
      setPayScheduleData((prev) => ({ ...prev, name: payRunName }));
      showToast("success", response?.responseDetails?.message || "Pay run renamed successfully");
    } else {
      showToast("error", response?.responseDetails?.message);
    }
    setEditNameField(false);
  };

  return showBulkImportDialog ? (
    <BulkImport
      setShowBulkImportDialog={setShowBulkImportDialog}
      payScheduleData={payScheduleData}
      payScheduleId={payScheduleId}
    />
  ) : (
    <>
      <React.Fragment>
        <ConfirmationDialog
          open={showConfirmationDialog}
          onClose={handleCancelClose}
          onConfirm={handleConfirmDialog}
          title={pendingAction === "revertDraft" ? "Revert to Draft" : "Reinitiate"}
          message={
            pendingAction === "revertDraft"
              ? "Reverting to Draft will move this pay schedule back to Draft status and clear the current in-progress payroll data. Are you sure you want to proceed?"
              : "Once you rerun the payrun, all updated earning details and manual adjustments will be lost. Are you sure you want to proceed?"
          }
          confirmText={"Confirm"}
          cancelText="Cancel"
        />
        <ConfirmationDialog
          open={showStartProcessingDialog}
          onClose={() => setShowStartProcessingDialog(false)}
          onConfirm={handleStartProcessing}
          title={"Initiate Payrun"}
          confirmText={"Continue"}
          showChildren={true}
          cancelText="Cancel"
        >
          <Mui.Box>
            <Mui.Box sx={{ mb: 2 }}>
              <Mui.Typography sx={{ fontWeight: 600 }}>
                Select how employee pay should be calculated
              </Mui.Typography>
              <Mui.Typography {...infoStyle}>
                Choose whether to calculate pay by Shift or Hours for this pay
                period.
              </Mui.Typography>
            </Mui.Box>
            <Mui.RadioGroup
              row
              value={paymentBasedOn}
              onChange={hanldePaymentBasedOn}
              sx={{
                display: "flex",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              {paymentOptions.map((opt) => {
                const isActive = paymentBasedOn === opt.id;
                return (
                  <Mui.Box key={opt.id} sx={cardStyle(isActive)}>
                    <Mui.Box sx={{ display: "flex", alignItems: "center" }}>
                      <Mui.Radio value={opt.id} />
                      <Mui.Typography
                        fontWeight={"medium"}
                        sx={{
                          color:
                            paymentBasedOn === opt.id
                              ? themes?.stepActiveColor
                              : "inherit",
                        }}
                      >
                        {opt.label}
                      </Mui.Typography>
                    </Mui.Box>
                    <Mui.Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        marginLeft: "32px",
                        maxWidth: 250,
                        wordBreak: "break-word",
                      }}
                    >
                      {opt.description}
                    </Mui.Typography>
                  </Mui.Box>
                );
              })}
            </Mui.RadioGroup>
          </Mui.Box>
        </ConfirmationDialog>
        <Mui.Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mb={3}
          flexWrap="wrap"
        >
          <Mui.Grid item>
            <Mui.Stack direction="Row">
              <BackArrow
                actionFunction={() => {
                  setViewPayRunScreen(false);
                  dispatch(setGlobalSearchValue(""));
                  setSocketCompleted(false);
                  setSelectedFilters([]);
                  setFilterValues({});
                  setSortRules([]);
                }}
              />
              <Mui.Box>
                {editNameField ? (
                  <Mui.TextField
                    value={payRunName}
                    onChange={(event) => setPayRunName(event.target.value)}
                    onBlur={updatePayRunName}
                    autoFocus
                    size="small"
                    variant="standard"
                    sx={{ "& .MuiInputBase-input": { fontSize: "1.25rem", fontWeight: 600 } }}
                    inputProps={{ maxLength: 255 }}
                  />
                ) : (
                  <Mui.Stack direction="row" alignItems="center" spacing={0.5}>
                    <Mui.Typography
                      variant="h6"
                      fontWeight={600}
                      onDoubleClick={() => {
                        setPayRunName(payScheduleData?.name);
                        setEditNameField(true);
                      }}
                      sx={{ cursor: "pointer" }}
                    >
                      {payScheduleData?.name}
                    </Mui.Typography>
                    <Mui.IconButton
                      size="small"
                      onClick={() => {
                        setPayRunName(payScheduleData?.name);
                        setEditNameField(true);
                      }}
                    >
                      <Edit fontSize="small" />
                    </Mui.IconButton>
                  </Mui.Stack>
                )}
                <Mui.Typography variant="body2" color="text.secondary">
                  Period:{" "}
                  {`${payScheduleData?.start_date} - ${payScheduleData?.end_date}`}
                </Mui.Typography>
              </Mui.Box>
            </Mui.Stack>
          </Mui.Grid>

          <Mui.Grid
            item
            sx={{ display: "flex", alignItems: "center", gap: 1, mr: 2 }}
          >
            <Mui.Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.75,
                px: 1.5,
                py: 0.5,
                borderRadius: 5,
                backgroundColor: "grey.100",
              }}
            >
              <Mui.Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor:
                    payScheduleData?.status === "Draft"
                      ? "#a89ef3"
                      : payScheduleData?.status === "Submitted"
                        ? "#7e8180"
                        : "#2E7D32",
                }}
              />
              <Mui.Typography variant="body2" sx={{ color: "text.secondary" }}>
                Status:
              </Mui.Typography>
              <Mui.Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  color:
                    payScheduleData?.status === "Draft"
                      ? "#a89ef3"
                      : payScheduleData?.status === "Submitted"
                        ? "#7e8180"
                        : "#2E7D32",
                }}
              >
                {payScheduleData?.status === "Inprogress"
                  ? "In Progress"
                  : payScheduleData?.status}
              </Mui.Typography>
            </Mui.Box>
            {payScheduleData?.status === "Draft" ? (
              <CustomButton
                actionName="Start Processing"
                actionFuntion={() => setShowStartProcessingDialog(true)}
                disableAction={isStartingProcess}
              />
            ) : payScheduleData?.status === "Inprogress" ? (
              <CustomButton
                actionName="Complete Processing"
                actionFuntion={() => {
                  handleApproveRejectReopen("Ready for Review", 0);
                }}
                disableAction={isApproveRejectLoading}
              />
            ) : payScheduleData?.status === "Ready for Review" ? (
              <CustomButton
                actionName="Submit for Approval"
                actionFuntion={() => {
                  handleApproveRejectReopen("Submitted", 1);
                }}
                disableAction={isApproveRejectLoading}
              />
            ) : null}
          </Mui.Grid>
        </Mui.Grid>
        {readyForPayrollWaiting && showIncompleteDataBanner && (
          <Mui.Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              flexWrap: "wrap",
              mb: 3,
              px: 2,
              py: 1.5,
              borderRadius: 2,
              backgroundColor: "#FFF8E7",
              border: "1px solid #FBE3B5",
            }}
          >
            <Mui.Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
              <Error sx={{ color: "#F59E0B", mt: "2px" }} fontSize="small" />
              <Mui.Box>
                <Mui.Typography
                  variant="body2"
                  sx={{ fontWeight: "bold", color: "text.primary" }}
                >
                  Payroll data may be incomplete
                </Mui.Typography>
                <Mui.Typography variant="body2" sx={{ color: "text.secondary" }}>
                  Some attendance data may still be processing. Refresh the
                  page to check for the latest payroll data.
                </Mui.Typography>
              </Mui.Box>
            </Mui.Box>
            <Mui.Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CustomButtonWithOutLoader
                actionName="Refresh"
                AddIcon={<Autorenew fontSize="small" />}
                actionFuntion={handleIncompleteDataRefresh}
              />
              <Mui.IconButton
                size="small"
                onClick={() => setShowIncompleteDataBanner(false)}
              >
                <Close fontSize="small" />
              </Mui.IconButton>
            </Mui.Box>
          </Mui.Box>
        )}
        <Mui.Card
          sx={{
            mb: 3,
            boxShadow: "none",
            border: "1px solid #e0e0e0",
            overflow: "visible",
          }}
        >
          <Mui.CardContent
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              overflow: "visible",
            }}
          >
            <Mui.Box sx={{ overflow: "visible" }}>
              <Mui.FormControl
                size="small"
                sx={{
                  minWidth: 250,
                  overflow: "visible",
                  position: "relative",
                }}
              >
                <CustomAutoComplete
                  dataList={summaryDetails}
                  selectedValue={summaryName}
                  updateDataFunction={handleSummaryDetails}
                  placeHolder="Select the summary"
                  fullWidth
                  popperSx={{ zIndex: 9999 }}
                />
              </Mui.FormControl>
            </Mui.Box>
            <Mui.Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {{
                Inprogress: (
                  <>
                    <CustomButtonWithBorder
                      actionName="Import Data"
                      AddIcon={<CloudUpload fontSize="small" />}
                      actionFuntion={() => {
                        setShowBulkImportDialog(true);
                      }}
                    />
                    <CustomButtonWithBorder
                      actionName="Recalculate"
                      AddIcon={<Calculate fontSize="small" />}
                      actionFuntion={() => {
                        handleRecalculate(true);
                      }}
                      disableAction={isRecalculating}
                    />
                    <Mui.Button
                      variant="outlined"
                      size="medium"
                      onClick={(event) =>
                        setMoreMenuAnchorEl(event.currentTarget)
                      }
                      startIcon={<MoreVert fontSize="small" />}
                      endIcon={<KeyboardArrowDown fontSize="small" />}
                      sx={{
                        textTransform: "capitalize",
                        borderColor: "grey.400",
                        color: "text.primary",
                        "&:hover": { borderColor: "grey.600" },
                      }}
                    >
                      More
                    </Mui.Button>
                    <Mui.Menu
                      anchorEl={moreMenuAnchorEl}
                      open={Boolean(moreMenuAnchorEl)}
                      onClose={() => setMoreMenuAnchorEl(null)}
                    >
                      <Mui.MenuItem
                        onClick={() => {
                          setMoreMenuAnchorEl(null);
                          setPendingAction("reinitiate");
                          setShowConfirmationDialog(true);
                        }}
                      >
                        <Autorenew
                          fontSize="small"
                          sx={{ color: "#16A34A", mr: 1 }}
                        />
                        Re Initiate
                      </Mui.MenuItem>
                      <Mui.MenuItem
                        onClick={() => {
                          setMoreMenuAnchorEl(null);
                          setPendingAction("revertDraft");
                          setShowConfirmationDialog(true);
                        }}
                      >
                        <Undo
                          fontSize="small"
                          sx={{ color: "#D97706", mr: 1 }}
                        />
                        Revert to Draft
                      </Mui.MenuItem>
                    </Mui.Menu>
                  </>
                ),

                "Ready for Review": (
                  <>
                    <Mui.Button
                      variant="outlined"
                      size="medium"
                      onClick={(event) =>
                        setMoreMenuAnchorEl(event.currentTarget)
                      }
                      startIcon={<MoreVert fontSize="small" />}
                      endIcon={<KeyboardArrowDown fontSize="small" />}
                      sx={{
                        textTransform: "capitalize",
                        borderColor: "grey.400",
                        color: "text.primary",
                        "&:hover": { borderColor: "grey.600" },
                      }}
                    >
                      More
                    </Mui.Button>
                    <Mui.Menu
                      anchorEl={moreMenuAnchorEl}
                      open={Boolean(moreMenuAnchorEl)}
                      onClose={() => setMoreMenuAnchorEl(null)}
                    >
                      <Mui.MenuItem
                        onClick={() => {
                          setMoreMenuAnchorEl(null);
                          handleApproveRejectReopen("Inprogress", 0);
                        }}
                      >
                        <RestartAlt
                          fontSize="small"
                          sx={{ color: "#1D4ED8", mr: 1 }}
                        />
                        Revert to In Progress
                      </Mui.MenuItem>
                      <Mui.MenuItem
                        onClick={() => {
                          setMoreMenuAnchorEl(null);
                          setPendingAction("revertDraft");
                          setShowConfirmationDialog(true);
                        }}
                      >
                        <Undo
                          fontSize="small"
                          sx={{ color: "#D97706", mr: 1 }}
                        />
                        Revert to Draft
                      </Mui.MenuItem>
                    </Mui.Menu>
                  </>
                ),

                Submitted: (
                  <>
                    <CustomButtonWithBorder
                      actionName="Approve"
                      actionFuntion={() => {
                        handleApproveRejectReopen("Approved", 2);
                      }}
                      disableAction={isApproveRejectLoading}
                    />
                    <CustomButtonWithBorder
                      actionName="Reject"
                      handleColor={true}
                      actionFuntion={() => {
                        handleApproveRejectReopen("Rejected", 0);
                      }}
                      disableAction={isApproveRejectLoading}
                    />
                  </>
                ),

                Approved: (
                  <>
                    {/* <CustomButtonWithBorder
                      actionName="Disburse"
                      actionFuntion={() => {
                        handleApproveRejectReopen("Disburse", 2);
                      }}
                    /> */}
                    <CustomButton
                      actionName="Reopen"
                      actionFuntion={() => {
                        handleApproveRejectReopen("Reopened", 0);
                      }}
                      disableAction={isApproveRejectLoading}
                    />
                  </>
                ),
              }[payScheduleData?.status] || null}
            </Mui.Box>
          </Mui.CardContent>
        </Mui.Card>
        {socketCompleted && (
          <Mui.Box sx={{ flexGrow: 1, overflow: "auto", pt: 0, mb: 2 }}>
            <Mui.Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 4,
              }}
            >
              {payrollData.map((item) => {
                const IconComponent = item.icon;
                return (
                  <Mui.Card
                    key={item.id}
                    sx={{
                      width: 200,
                      height: 123,
                      bgcolor: themes?.whiteColor,
                      borderRadius: 1,
                      boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
                      border: `0.5px solid ${item.iconBorderColor}`,
                    }}
                  >
                    <Mui.CardContent
                      sx={{
                        p: 2,
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                      }}
                    >
                      <Mui.Box
                        sx={{
                          width: 35,
                          height: 35,
                          bgcolor: item.iconBgColor,
                          border: `0.5px solid ${item.iconBorderColor}`,
                          borderRadius: 1,
                          boxShadow: "0px 1px 2px rgba(0,0,0,0.25)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mb: 1.5,
                        }}
                      >
                        <IconComponent
                          width={16}
                          height={16}
                          style={{ color: item.iconColor, padding: 2 }}
                        />
                      </Mui.Box>
                      <Mui.Typography
                        variant="body1"
                        sx={{
                          fontWeight: 600,
                          mb: "auto",
                        }}
                      >
                        {item.label}
                      </Mui.Typography>
                      <Mui.Typography
                        variant="h6"
                        sx={{
                          fontWeight: 700,
                          color: "#32325D",
                        }}
                      >
                        {item.value}
                      </Mui.Typography>
                    </Mui.CardContent>
                  </Mui.Card>
                );
              })}
            </Mui.Box>
          </Mui.Box>
        )}

        {isProcessing && (
          <>
            <Mui.Box
              sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.15)",
                zIndex: (theme) => theme.zIndex.drawer + 999,
              }}
            />

            <Mui.Box
              sx={{
                position: "relative",
                zIndex: (theme) => theme.zIndex.drawer + 1000,
                display: "flex",
                flexDirection: "row",
                alignItems: "stretch",
                gap: 2,
                mb: 3,
              }}
            >
              <Mui.Box
                sx={{
                  width: 80,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Mui.Box
                  sx={{
                    width: 55,
                    height: 55,
                    borderRadius: "50%",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Mui.CircularProgress
                    size={55}
                    thickness={4}
                    sx={{
                      color: "#4cd964",
                      position: "absolute",
                      animationDuration: "1.2s",
                    }}
                  />

                  <img
                    src={comLogo}
                    alt="Company Logo"
                    style={{
                      width: 28,
                      height: 28,
                      objectFit: "contain",
                      zIndex: 10,
                    }}
                  />
                </Mui.Box>

                <Mui.Typography
                  variant="caption"
                  sx={{
                    color: "#00a65a",
                    fontWeight: 600,
                    mt: 1,
                  }}
                >
                  Processing
                </Mui.Typography>
              </Mui.Box>

              <Mui.Box
                sx={{
                  flexGrow: 1,
                  bgcolor: "#fffdd7",
                  borderRadius: 1,
                  display: "flex",
                  alignItems: "center",
                  px: 3,
                }}
              >
                <Mui.Typography
                  variant="body2"
                  sx={{
                    color: "#444",
                    fontSize: 15,
                    fontWeight: 500,
                  }}
                >
                  {processingMessage}
                </Mui.Typography>
              </Mui.Box>
            </Mui.Box>
          </>
        )}
        <Mui.Grid container>{renderComponent()}</Mui.Grid>
      </React.Fragment>
    </>
  );
};
